export default __webpack_public_path__ + "static/media/View_alt_fill.ac1cf90c.svg";